import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export class NoCamWidgetImage extends PureComponent {

    static displayName = 'NoCamWidgetImage';

    static propTypes = {
        isMobile: PropTypes.bool,
        isDesktop: PropTypes.bool,
        isTablet: PropTypes.bool,
    }

    render(){
        const { isDesktop, isTablet, isMobile } = this.props;
        let width, height;
        if (isDesktop) {
            width = 80;
            height = 80;
        }else if( isTablet){
            width = 60;
            height = 60;
        }else if(isMobile){
            width = 40;
            height = 40;
        }


        return (
            <svg width={width} height={height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect opacity="0.01" width="80" height="80" fill="#F3F3F3"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M28.8919 27.3767L17.8277 32.536C16.8266 33.0028 16.3935 34.1928 16.8603 35.1939L27.6794 58.3954C28.1462 59.3965 29.3361 59.8296 30.3372 59.3628L43.3868 53.2777C44.4298 55.5327 46.7122 57.0972 49.3601 57.0972C51.8645 57.0972 54.042 55.6976 55.1531 53.6379L28.8919 27.3767ZM56.9524 46.9519L74.404 38.8141C75.405 38.3473 75.8382 37.1573 75.3713 36.1562L64.5523 12.9547C64.0855 11.9537 62.8955 11.5206 61.8945 11.9874L34.6787 24.6783L56.9524 46.9519ZM14.5714 39.8032C14.4125 39.4626 14.0761 39.2398 13.7005 39.2265L6.48474 38.9706C4.98432 38.9173 3.96242 40.4747 4.60852 41.83L16.3709 66.5026C17.0149 67.8535 18.8601 68.0444 19.7671 66.8541L24.0027 61.2954C24.228 60.9997 24.2707 60.6035 24.1136 60.2667L14.5714 39.8032Z" fill="#000000"/>
                <rect x="11.5146" y="18.4852" width="6" height="74.1667" transform="rotate(-45 11.5146 18.4852)" fill="#000000"/>
            </svg>

        );
    }

}
